import React from 'react';
import { Async } from 'react-select';

const View = ({
  name,
  subId,
  placeholder,
  selected,
  loadingPlaceholder,
  searchPromptText,
  handleChange,
  getOptions,
}) => (
  <div className="form-group">
    <label>SubID {subId}</label>
    <Async
      name={name}
      value={selected}
      placeholder={placeholder}
      onChange={handleChange}
      loadOptions={getOptions}
      loadingPlaceholder={loadingPlaceholder}
      searchPromptText={searchPromptText}
      arrowRenderer={null}
      clearable={false}
      multi
      autoload
      alwaysOpened
      cacheOptions
    />
  </div>
);

export default View;
